import { motion } from "framer-motion";
import { CheckCircle2, FileCheck, Scale, KeyRound, ShieldCheck, UserCheck } from "lucide-react";

const items = [
  { icon: Scale, title: "RBI Compliance", desc: "Full alignment with RBI outsourcing guidelines for financial services." },
  { icon: FileCheck, title: "DPDP Act Ready", desc: "Designed from the ground up for India's Digital Personal Data Protection Act." },
  { icon: KeyRound, title: "End-to-End Encryption", desc: "All data encrypted in transit and at rest with AES-256." },
  { icon: ShieldCheck, title: "Audit Logs", desc: "Complete audit trail with explainable AI decisions." },
  { icon: UserCheck, title: "Consent Management", desc: "Purpose limitation and consent enforcement built into every flow." },
  { icon: CheckCircle2, title: "SOC 2 Aligned", desc: "Security practices aligned with SOC 2 Type II standards." },
];

export const ComplianceSection = () => (
  <section id="compliance" data-testid="compliance-section" className="py-24 md:py-32 relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-[#c9a84c] font-heading font-semibold text-sm tracking-widest uppercase mb-4">
            Compliance & Governance
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-foreground tracking-tight">
            Built for <span className="text-gradient-gold">Regulated</span> Industries
          </h2>
          <p className="font-body text-muted-foreground mt-6 leading-relaxed">
            Every Ojas AI product is designed with compliance at its core. We
            don't bolt security on — we architect it in from day one, meeting the
            stringent requirements of India's most regulated sectors.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4">
          {items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-start gap-3 glass-card rounded-lg p-4"
              data-testid={`compliance-item-${i}`}
            >
              <item.icon className="h-5 w-5 text-[#c9a84c] shrink-0 mt-0.5" />
              <div>
                <h3 className="font-heading font-semibold text-foreground text-sm">{item.title}</h3>
                <p className="font-body text-muted-foreground text-xs mt-1 leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
